import { QueryClient } from '@tanstack/react-query';
import { DriverEntity } from 'src/entities/Driver.entity';
import { PlanningsDriverEntity } from 'src/entities/PlanningsDriver.entity';

/**
 * useQueryPlanningsDriversのキャッシュを管理するクラス
 */
export class PlanningsDriversCache {
  constructor(private queryClient: QueryClient) {}

  /**
   * ドライバーを追加する
   */
  addDrivers(drivers: DriverEntity[]): void {
    const driversCache = this.queryClient.getQueriesData({ queryKey: ['useQueryPlanningsDrivers'] });
    driversCache.forEach(([queryCacheKey, cacheData]) => {
      if (cacheData && Array.isArray(cacheData)) {
        const typedCacheData = cacheData as DriverEntity[];
        this.queryClient.setQueryData(queryCacheKey, [...typedCacheData, ...drivers]);
      }
    });
  }

  /**
   * 指定されたIDのドライバーを削除する
   */
  removeDriverById(driverId: number): void {
    const driversCache = this.queryClient.getQueriesData({ queryKey: ['useQueryPlanningsDrivers'] });
    driversCache.forEach(([queryCacheKey, queryData]) => {
      if (queryData && Array.isArray(queryData)) {
        const updatedDrivers = queryData.filter((cache) => {
          const driver = cache as unknown as PlanningsDriverEntity;
          return driver && typeof driver === 'object' && 'id' in driver && driver.id !== driverId;
        });
        this.queryClient.setQueryData(queryCacheKey, updatedDrivers);
      }
    });
  }
}
